import { RouteRecordRaw } from "vue-router";

const aiAssistantRouter: RouteRecordRaw[] = [
    {
        path: "/aiAssistant",
        name: "AiAssistant",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/aiAssistant",
        meta: {
            title: "AI助手",
            icon: "icon-AI"
        },
        children: [
            {
                path: "index",
                name: "AiAssistantIndex",
                component: () => import("@/views/pages/aiAssistant/index.vue"),
                meta: {
                    title: "AI助手",
                    hidden: true,
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default aiAssistantRouter;
